import React from "react";
import DatePicker from "react-datepicker";
const kennitala = require('kennitala');
import { fetchCustomerFilterByContractType } from '../../../api/customers/actions';
import connectWithStore from '../../../utils/store';
import { store } from '../../../store';
import ConfirmSkilagrein from '../confirm-skilagrein'
import moment from 'moment'
import { formatNumber } from '../../../utils';

const styles = {
    salaryRow: { height: "60px"},
    rowInput: {margin:"0 10px", padding:0, width: "80%"},
    labelHelp: {fontSize: "80%"},
    skilagreinForm: {marginBottom: "20px"}    
};


function NumericInput(inp) {
  var numericKeys = '0123456789';

  // restricts input to numeric keys 0-9
  inp.addEventListener('keypress', function(e) {
    var event = e || window.event;
    var target = event.target;

    if (event.charCode == 0) {
      return;
    }

    if (-1 == numericKeys.indexOf(event.key)) {
      // Could notify the user that 0-9 is only acceptable input.
      event.preventDefault();
      return;
    }
  });

  // add the thousands separator when the user blurs
  inp.addEventListener('blur', function(e) {
    var event = e || window.event;
    var target = event.target;

    var tmp = target.value.replace(/[,.]/g, '');
    var val = formatNumber(Number(tmp));

    if (tmp == '') {
      target.value = '';
    } else {
      target.value = val;
    }
  });

  // strip the thousands separator when the user puts the input in focus.
  inp.addEventListener('focus', function(e) {
    var event = e || window.event;
    var target = event.target;
    var val = target.value.replace(/[,.]/g, '');

    target.value = val;
  });
}

const initalState = {
    step: 0,
    errors: {
        periodStart: '',
        periodEnd: '',                
    },
    periodRows: [],
    search: '',
    lastSearchIdx: 0
}


class ManualRegistration extends React.Component {
    
    constructor(props) {
        super(props)
        this.state = {
            ...initalState,
            periodStart: this.props.initialValues.periodStart,
            periodEnd: this.props.initialValues.periodEnd,
            periodDescription: this.props.initialValues.periodDescription,
        };
        this._nextRowId = 0;
        this.periodStart = React.createRef();
        this.periodEnd = React.createRef();
        this.periodDescription = React.createRef();
        this.addPeriodRow = this.addPeriodRow.bind(this);
        this.deletePeriodRow = this.deletePeriodRow.bind(this);
        this.renderPeriodRows = this.renderPeriodRows.bind(this);
        this.updatePeriodRow = this.updatePeriodRow.bind(this);
        this.onCustomersChange = this.onCustomersChange.bind(this);
        this.setDateField = this.setDateField.bind(this);
        this.keypressEvent = this.keypressEvent.bind(this);
        this.canProceedToReport = this.canProceedToReport.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isEmpty = this.isEmpty.bind(this);
    }

    componentDidMount() {

    }

    isEmpty(o) {
        return o && o.constructor === Object ? Object.keys(o).length === 0 : !o;
    } 

    componentDidUpdate(prevProps,prevState) {
        if (prevProps &&
            prevProps.customers && 
            (
                prevProps.customers.errorMessage !== this.props.customers.errorMessage ||
                JSON.stringify(prevProps.customers.lastLookup) !== JSON.stringify(this.props.customers.lastLookup)
            )
        ) {
            this.onCustomersChange(this.props.customers,this.props.customers.errorMessage);
        } else if (this.isEmpty(prevProps.customers.lastLookup) && Object.keys(this.props.customers.lastLookup).length) {
            this.onCustomersChange(this.props.customers,this.props.customers.errorMessage);
        }

        if (prevState &&
            prevState.periodRows &&
            prevState.periodRows.length < this.state.periodRows.length) {

            // ok we just added a new line
            // set the foucs to the kennitala entry
            let element = document.getElementById(`kennitala-${this.state.periodRows.length-1}`);
            if (element) {
                element.focus();
            }
        }
        if (this.state.periodRows.length == 0) {
            this.addPeriodRow();
        }
        this.attachNumericInputs();
    }

    attachNumericInputs() {
        const container = document.getElementById('period-rows');
        if (!container) return;
        const inputs = container.querySelectorAll('input.amount');
        inputs.forEach(inp => {
            // avoid double-binding
            if (inp.dataset.numericInited) return;
            NumericInput(inp);
            inp.dataset.numericInited = '1';
        });
    }    

    onCustomersChange(data, errorMsg) {
        const idx = this.state.lastSearchIdx;
        if (errorMsg.length > 0) {
            this.updatePeriodRow(idx, { name: '', error:'Ekki með samning!' });    
        } else {
            // we can not use lastLookup from data, as it will be empty if 
            // the user re-enters a kennitala
            const kennitala = document.getElementById('kennitala-'+idx).value.replace('-','');
            this.updatePeriodRow(idx, { name: data.peopleByKennitala[kennitala], error:'' });    
            
        }
    }


    updatePeriodRow(index, record) {
        if (Object.keys(record)[0] === 'totalSalary') {
            const totalSalary = record.totalSalary.replace(/[,.]/g, '');
            record['premium'] = formatNumber(Math.round(totalSalary * 0.04));
            record['counterPremium'] = formatNumber(Math.round(totalSalary * 0.02));
        }
        this.setState((prev) => {
            const periodRows = prev.periodRows.map((r, i) =>
                i === index ? { ...r, ...record  } : r
            );            
            return { periodRows };
        });
    }

    handleKennitala(index, record) {
        if (kennitala.isValid(record.kennitala) && kennitala.isPerson(record.kennitala)) {
            this.props.dispatch(fetchCustomerFilterByContractType(kennitala.clean(record.kennitala, true),null,'VID'));
            this.setState({ lastSearchIdx: index, search: record.kennitala });
            this.updatePeriodRow(index,{ error: '' });
        } else {
            this.setState({ lastSearchIdx: index, search: ''});
            this.updatePeriodRow(index,{ error: "Ógild kennitala" });
        }
    }

    addPeriodRow() {
        const newRow = {
            id: this._nextRowId++,
            kennitala: '',
            totalSalary: '',
            premium: '',
            counterPremium: '',
            error: '',
            name: ''
        };
        this.setState(prev => ({ periodRows: [...prev.periodRows, newRow] }));
        return true;
    }

    deletePeriodRow(index) {
        if (index > 0) {
            this.setState(prev => {
                const rows = prev.periodRows.slice();
                rows.splice(index, 1);
                return { periodRows: rows };
            });            
        }
        return true;
    }

    keypressEvent(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            if (e.target.id.indexOf('premium') !== -1) {
                e.target.setAttribute('readonly',true);                
            }

            const container = document.getElementById('period-rows');
            if (!container) return;
            const inputs = Array.from(
                container.querySelectorAll('input:not([type="hidden"]):not([disabled])')
            ).filter(el => el.offsetParent !== null || el.getClientRects().length > 0);
            if (!inputs.length) return;
            const idx = inputs.indexOf(document.activeElement);
            if (idx === inputs.length - 1) {
                // we are at the end so we add a new row
                this.addPeriodRow()

            } else {
                const nextIdx = (idx === -1) ? 0 : (idx + 1) % inputs.length;
                inputs[nextIdx].focus();
            }
        }
    }


    renderPeriodRows() {
        return this.state.periodRows.map((row, idx) => ( 
            <div key={row.id} className={`row salary-row row-${idx}`} style={styles.salaryRow}>
                <div className="col-sm"> 
                    <input 
                        id={`kennitala-${idx}`}
                        type="text"
                        name={`kennitala-${idx}`}
                        pattern="[0-9]{6}-*[0-9]{4}"
                        defaultValue={row.kennitala}                    
                        onChange={(e) => this.updatePeriodRow(idx, {kennitala: e.target.value})}
                        onBlur={(e) => this.handleKennitala(idx, {kennitala: e.target.value})}
                        style={styles.rowInput}
                        onKeyPress={this.keypressEvent}
                    />
                    { 
                        row.error != ''
                        ? <span className="error">{row.error}</span>
                        : <span>{row.name}</span>
                    }
                </div>
                <input 
                    id={`salary-${idx}`}
                    type="text"
                    pattern="[0-9,.]*"
                    name={`salary-${idx}`}
                    onChange={(e) => this.updatePeriodRow(idx,{totalSalary: e.target.value})}
                    defaultValue={row.totalSalary}
                    className="amount col-sm text-right"
                    style={styles.rowInput}
                    onKeyPress={this.keypressEvent}
                />
                kr.
                <input
                    id={`premium-${idx}`}
                    name={`premium-${idx}`}
                    type="text"
                    pattern="[0-9,.]*"
                    defaultValue={row.premium}
                    onChange={(e) => this.updatePeriodRow(idx,{premium: e.target.value})}
                    style={styles.rowInput}
                    onKeyPress={this.keypressEvent}
                    className="amount col-sm text-right"
                />
                kr.
                <input
                    id={`counter-premium-${idx}`}
                    name={`counter-premium-${idx}`}
                    type="text"
                    pattern="[0-9,.]*"
                    defaultValue={row.counterPremium}
                    onChange={(e) => this.updatePeriodRow(idx,{counterPremium: e.target.value})}
                    style={styles.rowInput}
                    onKeyPress={this.keypressEvent}
                    className="amount col-sm text-right"
                />
                kr.
                {idx > 0 
                    ? <button style={{backgroundColor: "#dc3149", color: "white", height:"28px", width:"24px"}} onClick={(e) => {e.preventDefault(); this.deletePeriodRow(idx);} }> - </button>
                    : <div style={{width:"24px"}}> </div>
                }
                {idx === this.state.periodRows.length - 1 
                    ? <button style={{backgroundColor: "#1e8927", color: "white", height:"28px", width:"24px"}} onClick={(e) => {e.preventDefault(); this.addPeriodRow();} }> + </button>
                    : <div style={{width:"24px"}}> </div>
                }
                
            </div>
        )
        );
    }

    setDateField(record) {
        const { periodStart, periodEnd } = {...this.state, ...record};
        
        // has the user edited the description?
        if (!(this.periodDescription && this.periodDescription.current && this.periodDescription.current.edited)) {
            record.periodDescription = periodDescription(
                periodStart,
                periodEnd,
            );
        }
        this.setState({...record});
    }

    canProceedToReport(e) {
        e.preventDefault();
        let idx = 0;
        let effectiveLines = 0;
        for (const row of this.state.periodRows) {
            if (row.error.length > 0 && row.kennitala.trim() !== '') {
                alert("Ógild kennitala í línu "+(idx+1)+".\nVinsamlegast lagfærðu til að halda áfram.");
                document.getElementById(`kennitala-${idx}`).focus();
                return;
            }
            if (row.kennitala.trim()) {
                effectiveLines++;
            }
            idx++;
        }
        if (effectiveLines) {
            this.setState({ step: 2 });
        } else {
            alert("Engin gögn til að senda.");
        }
    }

    handleSubmit(e) {
        const form = e.currentTarget;
        if (!form.checkValidity()) {
            form.reportValidity();
            e.preventDefault();
            return;
        }
        e.preventDefault();
        this.canProceedToReport(e);
    }    

    renderStep() {
        switch(this.state.step) {
            case 0:
                const validFormats = ['dd.MM.yyyy', 'dd MMM yyyy', 'dd/MM/yyyy', 'ddMMyyyy', 'dd-MM-yyyy',
                                    'dd.MM.yy', 'dd MM yy', 'dd/MM/yy', 'ddMMyy', 'dd-MM-yy',];
                return (
                    <div>
                        <div className="col-sm-6" style={{display:"flex"}}>
                            <label htmlFor="skilagrein-periodStart" className="col-sm-6 col-form-label">
                                Tímabil frá <small style={styles.labelHelp}>(t.d. DD.MM.ÁÁ)</small>
                                {this.state.errors.periodStart.length > 0 ?
                                    <span className="error"> ({this.state.errors.periodStart}) </span> : ''
                                }
                            </label>

                            <DatePicker
                                ref={this.periodStart}
                                selected={this.state.periodStart}
                                id="skilagrein-periodStart"
                                className="form-control text-sm-right col-8 d-block"
                                name="periodStart"
                                value={this.state.periodStart}
                                onChange={(date) => this.setDateField({ periodStart: date })}
                                dateFormat={validFormats}
                                locale="is"
                            >
                            </DatePicker>
                        </div>
                        <div className="col-sm-6" style={{display:"flex"}}>
                            <label htmlFor="skilagrein-periodEnd" className="col-sm-6 col-form-label">
                                Tímabil til <small style={styles.labelHelp}>(t.d. DD.MM.ÁÁ)</small>
                                {this.state.errors.periodEnd.length > 0 ?
                                    <span className="error"> ({this.state.errors.periodEnd}) </span> : ''
                                }
                            </label>

                            <DatePicker
                                ref={this.periodEnd}
                                selected={this.state.periodEnd}
                                id="skilagrein-periodEnd"
                                className="form-control text-sm-right col-8 d-block"
                                name="periodEnd"
                                onChange={(date) => this.setDateField({ periodEnd: date })}
                                value={this.state.periodEnd}
                                dateFormat={validFormats}
                                locale="is"
                            >
                            </DatePicker>
                        </div>
                        <div className="col-sm-6" style={{display:"flex"}}>
                            <label htmlFor="skilagrein-description" className="col-sm-6 col-form-label">
                                Lýsing 
                            </label>
                            <input 
                                ref={this.periodDescription}
                                type="text"
                                className="col-sm-8"
                                id="skilagrein-description" 
                                name="periodDescription" 
                                value={this.state.periodDescription}
                                onFocus = {(e) =>  e && e.target ? e.target.org_value = e.target.value : null }
                                onChange={(e) => this.setState({ periodDescription: e.value })}
                                onBlur = {(e) => e && e.target && e.target.org_value && e.target.org_value !== e.target.value ? e.target.edited = true : null} />
                        </div>

                        <button 
                            className="confirm-btn btn btn-primary xs-m-10"
                            onClick={(e) => {e.preventDefault();this.setState({ step: 1 });}}
                        >
                            Áfram
                        </button>
                        <button className="no-op-btn btn btn-outline-secondary xs-m-10">Engin Starfsemi</button>
                    </div>                        
                );
            case 1:
                return (
                    <div>
                        <div id="period-rows" className="container period-rows">
                            <div className="row period-rows-header" style={styles.salaryRow}>
                                <label className="col-sm col-form-label">
                                    Kennitala
                                </label>
                                <label className="col-sm col-form-label">
                                    Heildarlaun
                                </label>
                                <label className="col-sm col-form-label">
                                    Iðgjald
                                </label>
                                <label className="col-sm col-form-label">
                                    Mótframlag
                                </label>
                            </div>
                            {
                                this.renderPeriodRows()
                            }
                        </div>
                        <button 
                            className="back-btn btn btn-outline-secondary xs-m-10"
                            onClick={(e) => {e.preventDefault();this.setState({ step: 0 });}}
                        >
                            Til baka
                        </button>
                        <button type="submit" className="confirm-btn btn btn-primary xs-m-10">
                            Áfram
                        </button>
                    </div>
                )
            case 2:
                let periodRows = this.state.periodRows.filter(r => r.kennitala && r.kennitala.trim() !== '');
                return (
                    <div>
                        <ConfirmSkilagrein
                            skilagrein={
                                {
                                    description: this.state.periodDescription,
                                    period:{ first: this.state.periodStart, last: this.state.periodEnd },
                                    periodRows: periodRows
                                }
                            }
                            onBack={(e) => this.setState({ step: 1 })}
                            onFinalBack={(e) => this.setState(initalState)}
                        />
                    </div>                    
                )
        }
    }


    render() {
        return (<>
            <style>{`
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                    appearance: none;
                    margin: 0;
                }
                input[type="number"] {
                    -moz-appearance: textfield;
                }
            `}</style>        
            <form className={`step-${this.state.step} register-skilagrein`} onSubmit={this.handleSubmit}>
                <div className="register-skilagrein" style={styles.skilagreinForm}>
                    {this.renderStep()}
                </div>
            </form>
        </>);
    }
}


function periodDescription(first, last) {
    return `Skilagr. ${moment(first).format('D.M.YYYY')} - ${moment(last).format('D.M.YYYY')}`
}

function prevMonthRange() {
    const now = new Date();
    const prevMonth = (now.getMonth() + 11) % 12;
    const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    const first = new Date(year, prevMonth, 1);
    const last = new Date(year, prevMonth + 1, 0);
    return { first, last };
}

const { first: defaultPeriodStart, last: defaultPeriodEnd } = prevMonthRange();

ManualRegistration.defaultProps = {
    initialValues: {
        periodStart: defaultPeriodStart,
        periodEnd: defaultPeriodEnd,
        periodDescription: periodDescription(defaultPeriodStart,defaultPeriodEnd)
    }
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        companyDetails: {}
    };
    f.customers = (state.customers === undefined) ? {} : state.customers;
    f.companyDetails = (state.companyDetails === undefined) ? {} : state.companyDetails;

    return f;
}


export default connectWithStore(store, ManualRegistration, mapStateToProps);

//export default ManualRegistration